module.exports = __webpack_public_path__ + "static/img/4.b993d25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/4.png
// module id = xSjk
// module chunks = 0